import { createFormatter } from 'pejer/src/helpers'
import { businessColumns } from 'pejer/src/stores/columns/Businesses'
import { connectedAccountsColumns } from 'pejer/src/stores/columns/ConnectedAccounts'
import { customersColumns } from 'pejer/src/stores/columns/Customers'
import { kidNorwayTransactionsColumns } from 'pejer/src/stores/columns/KidNorwayTransactions'
import { paymentsColumns } from 'pejer/src/stores/columns/Payments'
import { payoutsColumns } from 'pejer/src/stores/columns/Payouts'
import personsOfInterestColumns from 'pejer/src/stores/columns/PersonsOfInterest'
import { refundsColumns } from 'pejer/src/stores/columns/Refunds'
import { usersColumns } from 'pejer/src/stores/columns/Users'
import { defaultTables, defaultUrls } from 'pejer/src/stores/config'
import { Config, ConfigUrls, TableConfig } from 'pejer/src/types/base'
import { InvoiceDetails } from './types/invoice'

export const userTables = {
  ...defaultTables,
} satisfies TableConfig

const urls = {
  ...defaultUrls,
  onBoarding: {
    getAccount: {
      path: '/api/v2/onBoarding/{LinkID}/account',
      method: 'GET',
    },
    onBoardAccount: {
      path: '/api/onBoarding/{LinkID}/onBoardAccount',
      method: 'POST',
    },
    saveTemporary: {
      path: '/api/onBoarding/{LinkID}/saveTemporary',
      method: 'POST',
    },
    getSignAccount: {
      path: '/api/onBoarding/sign/{LinkID}/account',
      method: 'GET',
    },
    getOverviewInformation: {
      path: '/api/onBoarding/overview/{connectedAccountID}',
      method: 'GET',
    },
    signUsingLink: {
      path: '/api/onBoarding/sign/{LinkID}',
      method: 'POST',
    },
    getProffData: {
      path: '/api/onBoarding/proffData',
      method: 'GET',
    },
    editAccountSettings: {
      path: '/api/onBoarding/{LinkID}/editAccountSettings',
      method: 'PATCH',
    },
    verifySignatures: {
      path: '/api/onBoarding/verifySignatureCombination',
      method: 'POST',
    },
  },
  invoice: {
    get: {
      path: '/payments/{paymentReferenceID}/invoice',
      method: 'GET',
      formatter: createFormatter<InvoiceDetails>(),
    },
  },
} as const satisfies ConfigUrls

export const config = {
  cookieNames: {
    platformToken: 'x-platform-token',
    enviroment: 'x-platform-environment',
  },
  urls,
  schema: {
    tables: userTables,
  },
  columns: {
    payments: paymentsColumns,
    customers: customersColumns,
    payouts: payoutsColumns,
    connectedAccounts: connectedAccountsColumns,
    users: usersColumns,
    businesses: businessColumns,
    personsOfInterest: personsOfInterestColumns,
    kidNorwayTransactions: kidNorwayTransactionsColumns,
    refunds: refundsColumns,
  },
} satisfies Config<typeof urls, typeof userTables>
